import { render, staticRenderFns } from "./stationOscillogram.vue?vue&type=template&id=d89de27c&scoped=true&"
import script from "./stationOscillogram.vue?vue&type=script&lang=js&"
export * from "./stationOscillogram.vue?vue&type=script&lang=js&"
import style0 from "./stationOscillogram.vue?vue&type=style&index=0&id=d89de27c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d89de27c",
  null
  
)

export default component.exports